export const ACTION_GET_USER_PRODUCT_DETAILS = '/OrderLines/GetMyProductDetail';

export const ACTION_REMOVE_MY_PRODUCT = '/OrderLines/RemoveMyProduct';
